import { Injectable } from '@angular/core';
import { environment } from '@app/environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  LendioResponse,
  ObsLendioResponse,
  ObsPaginatedLendioResponse,
  PaginatedLendioResponse
} from '@app/app/interfaces/lendio-response';
import { Integration, IntegrationActivity } from '@app/app/interfaces/integration.model';

@Injectable({
  providedIn: 'root'
})
export class IntegrationsService {
  private baseUrl = environment.apiUrl + '/lender-portal/integrations';

  constructor(
    private httpClient: HttpClient,
  ) {}

  getIntegrations(): ObsLendioResponse<Integration[]> {
    return this.httpClient.get<LendioResponse<Integration[]>>(this.baseUrl);
  }

  getIntegrationDetail(customerIntegrationId: number): ObsLendioResponse<Integration> {
    return this.httpClient.get<LendioResponse<Integration>>(`${this.baseUrl}/${customerIntegrationId}`)
  }

  getIntegrationActivities(customerIntegrationId: number): ObsPaginatedLendioResponse<IntegrationActivity> {
    return this.httpClient.get<PaginatedLendioResponse<IntegrationActivity>>(`${this.baseUrl}/${customerIntegrationId}/activity`)
  }

}
